class FileService {
  async downloadFile(preSignedUrl: string) {
    const data = await fetch(preSignedUrl, {
      method: "GET",
    });
    return data.blob();
  }
}

export default new FileService();
